import { combineReducers } from 'redux';

import { cartReducer } from '@r1-frontend/entities/Cart';
import contactAddress from '@r1-frontend/entities/ContactAddress';
import { contactDetails } from '@r1-frontend/entities/ContactDetail';
import auth from '@r1-frontend/entities/stores/auth/reducer';
import city from '@r1-frontend/entities/stores/city/reducer';

import citySelect from '~/src/components/CitySelectContainer/store/reducer';
import { reducer as vasReducer } from '~/src/entities/vases/store/reducer';
import changePaymentDate from '~/src/features/changeDateLK/store/reducer';
import tvSubscriptions from '~/src/features/domru-tv/packages/store/reducers';
import { reducer as search } from '~/src/features/faq/components/Search/store/reducer';
import serviceHelpFAQ from '~/src/features/faq/store/reducer';
import { fullBuyReducer } from '~/src/features/full-buy/store';
import internetReducer from '~/src/features/internet/store/reducer';
import servicesForSuspension from '~/src/features/managementAgreement/SuspendServices/store';
import { onlineBuyReducer } from '~/src/features/online-buy/store';
import seasonTicketPayment from '~/src/features/payments-abn/components/SeasonTicketPayment/store/reducer';
import payment from '~/src/features/payments-abn/store/reducers';
import specOffers from '~/src/features/specialOffersContainer/store/reducer';
import { wifiReducer } from '~/src/features/wifi/store/reducer';
import bundles from '~/src/store/reducers/bundles';
import catchup from '~/src/store/reducers/catchup';
import clientEquipmentInfo from '~/src/store/reducers/clientEqipmentInfo';
import faq from '~/src/store/reducers/faq';
import feedback from '~/src/store/reducers/feedback';
import filteredBundles from '~/src/store/reducers/filteredBundles';
import intercom from '~/src/store/reducers/intercom';
import internet from '~/src/store/reducers/internet';
import loyaltyReducer from '~/src/store/reducers/loyalty';
import mail from '~/src/store/reducers/mail';
import main from '~/src/store/reducers/main';
import news from '~/src/store/reducers/news';
import { popups } from '~/src/store/reducers/popups';
import promo from '~/src/store/reducers/promo';
import quiz from '~/src/store/reducers/quiz';
import routers from '~/src/store/reducers/routers';
import settingsPhone from '~/src/store/reducers/settingsPhone';
import stories from '~/src/store/reducers/stories';
import tags from '~/src/store/reducers/tags';
import ticket from '~/src/store/reducers/ticket';
import tvBoxes from '~/src/store/reducers/tvboxes';
import tvPackages from '~/src/store/reducers/tvPackages';
import vas from '~/src/store/reducers/vas';
import wholesaleCheaperData from '~/src/store/reducers/wholesaleCheaper';

// Свойства комбинируем в алфавитном порядке
export default combineReducers({
    auth,
    bundles,
    cart: cartReducer,
    catchup,
    changePaymentDate,
    city,
    citySelect,
    clientEquipmentInfo,
    contactAddress,
    contactDetails,
    faq,
    feedback,
    filteredBundles,
    fullBuy: fullBuyReducer,
    intercom,
    internet,
    internetReducer,
    loyalty: loyaltyReducer,
    mail,
    main,
    news,
    onlineBuy: onlineBuyReducer,
    payment,
    popups,
    promo,
    quiz,
    routers,
    seasonTicketPayment,
    serviceHelpFAQ,
    search,
    servicesForSuspension,
    stories,
    settingsPhone,
    specOffers,
    tags,
    ticket,
    tvBoxes,
    tvPackages,
    tvSubscriptions,
    /**
     * @deprecated use vasReducer
     * @todo remove after moving on api-widgets
     */
    vas,
    vasReducer,
    wholesaleCheaperData,
    wifi: wifiReducer,
});
